import React, { useState } from 'react'
import { useStyles } from './styles'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Input, Loading, PageTitle } from 'src/components'
import { useGetPastureById } from 'src/hooks/api/pasture/useGetPastureById'
import { Grid } from '@material-ui/core'
import { SelectAnimalModal } from '../../../../components/SelectAnimalModal'
import { usePastureModal } from '../hooks/usePastureModal'
import { usePastureHistoricModal } from '../hooks/usePastureHistoricModal'
import { useConfirmDeleteModal } from '../hooks/useConfirmDeleteModal'
import { PastureClassification } from '../components/PastureClassification'
import ROUTES from 'src/constants/routes'
import { NotFoundError } from 'src/utils/NotFoundError'
import { useUpdatePasture } from 'src/hooks/api/pasture/mutations/useUpadePasture'
import { PastureForm } from 'src/@types/validations/Local'

export const PastureDetail: React.FC = () => {
  const [selected, setSelected] = useState<string[]>([])
  const [showAnimaisFromLocalModal, setShowAnimaisFromLocalModal] = useState<boolean>(false)
  const { id } = useParams()

  const navigate = useNavigate()
  const styles = useStyles()

  const { data: pastureData, isLoading, isError, refetch, error } = useGetPastureById(id as string)

  const { open: openHistoric, PastureHistoricModal } = usePastureHistoricModal(id)
  const { mutateAsync: deletePasture, isPending: isDeleting } = useUpdatePasture()

  const animalPastureList = pastureData?.animais || []
  const { open: openPastureModal, PastureModal } = usePastureModal(id)

  const handleDeletePasture = async () => {
    if (!pastureData) return

    await deletePasture({
      ...pastureData,
      acao: 'Removido'
    } as PastureForm)
    navigate(ROUTES.LOCATIONS.ROOT)
  }

  const { open: openConfirmDelete, ConfirmationDeleteModal } = useConfirmDeleteModal({
    confirmDelete: handleDeletePasture,
    isDeleting
  })

  if (isError && (error as any)?.status === 404) {
    throw new NotFoundError('Pasture not found')
  }

  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <PageTitle breadcrumbLink={{ to: ROUTES.LOCATIONS.ROOT, text: 'Locais' }} title='Detalhes do local' />
        </div>
      </div>

      {isLoading || isError ? (
        <Loading isError={isError} refetch={refetch} />
      ) : (
        <>
          <div className={styles.content}>
            <div>
              <section>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Input
                      label='Nome do local'
                      id='name'
                      placeholder='Nome do local'
                      disabled
                      type='text'
                      value={pastureData?.descricao || ''}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Input
                      label='Área total (hectares)'
                      id='area'
                      placeholder='Área total: ex. 150'
                      disabled
                      type='text'
                      value={pastureData?.area || ''}
                    />
                  </Grid>
                </Grid>
              </section>
              <PastureClassification
                data={pastureData!}
                openHistoric={openHistoric}
                setShowAnimaisFromLocalModal={setShowAnimaisFromLocalModal}
              />
            </div>
            <footer>
              <div className={styles.footerContent}>
                <Button onClick={openConfirmDelete} className={styles.deleteButton}>
                  Excluir
                </Button>
                <Button onClick={openPastureModal}>Editar Local</Button>
              </div>
            </footer>
          </div>
        </>
      )}
      <SelectAnimalModal
        animals={animalPastureList}
        isOpen={showAnimaisFromLocalModal}
        onClose={() => setShowAnimaisFromLocalModal(false)}
        value={selected}
        onChange={setSelected}
        disableSelected
        onClickItem={({ idAnimal }) => navigate(`/gado/${idAnimal}`)}
      />
      <PastureModal />
      <PastureHistoricModal />
      <ConfirmationDeleteModal />
    </>
  )
}
